// Lightweight magnetic and tilt effects without deps

export function initMagnetic(root = document) {
  const elements = Array.from(root.querySelectorAll('.magnetic'));
  if (!elements.length) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;
  elements.forEach((el) => {
    const strength = parseFloat(el.getAttribute('data-magnet-strength') || '18');
    let raf = 0;
    function onMouseMove(e) {
      cancelAnimationFrame(raf);
      const rect = el.getBoundingClientRect();
      const relX = e.clientX - (rect.left + rect.width / 2);
      const relY = e.clientY - (rect.top + rect.height / 2);
      raf = requestAnimationFrame(() => {
        el.style.transform = `translate(${relX / strength}px, ${relY / strength}px)`;
      });
    }
    function onMouseLeave() {
      cancelAnimationFrame(raf);
      el.style.transform = 'translate(0,0)';
    }
    el.addEventListener('mousemove', onMouseMove);
    el.addEventListener('mouseleave', onMouseLeave);
  });
}

export function initTilt(root = document) {
  const cards = Array.from(root.querySelectorAll('.tilt-card'));
  if (!cards.length) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;
  cards.forEach((card) => {
    let raf = 0;
    const maxTilt = parseFloat(card.getAttribute('data-tilt-max') || '6');
    function onMove(e) {
      cancelAnimationFrame(raf);
      const rect = card.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;
      const rx = (py - 0.5) * -2 * maxTilt; // rotateX
      const ry = (px - 0.5) * 2 * maxTilt;  // rotateY
      raf = requestAnimationFrame(() => {
        card.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) translateZ(0)`;
      });
    }
    function onLeave() {
      cancelAnimationFrame(raf);
      card.style.transform = 'perspective(900px) rotateX(0) rotateY(0) translateZ(0)';
    }
    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseleave', onLeave);
  });
}

export function initCursorAura() {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;
  let aura = document.querySelector('.cursor-aura');
  if (!aura) return;
  let raf = 0;
  let targetX = 0, targetY = 0;
  function onMove(e) {
    targetX = e.clientX;
    targetY = e.clientY;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      aura.style.transform = `translate(${targetX - 12}px, ${targetY - 12}px)`;
    });
  }
  window.addEventListener('mousemove', onMove, { passive: true });
}

export function initSpotlight(root = document) {
  const items = Array.from(root.querySelectorAll('.spotlight-card'));
  if (!items.length) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;
  items.forEach((el) => {
    function onMove(e) {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      el.style.setProperty('--mx', `${x}px`);
      el.style.setProperty('--my', `${y}px`);
    }
    el.addEventListener('mousemove', onMove);
  });
}

export function initParallax(root = document) {
  const els = Array.from(root.querySelectorAll('.parallax-el'));
  if (!els.length) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;
  function onScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    els.forEach((el) => {
      const speed = parseFloat(el.getAttribute('data-parallax-speed') || '0.15');
      el.style.transform = `translateY(${Math.round(scrollY * speed)}px)`;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}


